import { render, staticRenderFns } from "./histograma.vue?vue&type=template&id=e6ff3730&lang=pug&"
import script from "./histograma.vue?vue&type=script&lang=js&"
export * from "./histograma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports